var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" Create API Key ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.id))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "App Name", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.appName))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Key Prefix", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                      _vm._v(_vm._s(row.keyPrefix) + "..."),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Permissions", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._l(row.permissions || [], function (perm, index) {
                      return _c(
                        "el-tag",
                        {
                          key: index,
                          staticStyle: {
                            "margin-right": "4px",
                            "margin-bottom": "4px",
                          },
                          attrs: { size: "mini" },
                        },
                        [_vm._v(" " + _vm._s(perm) + " ")]
                      )
                    }),
                    !row.permissions || row.permissions.length === 0
                      ? _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                          _vm._v("None"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Rate Limit", width: "110", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(row.rateLimit) + "/hr")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Active", width: "90", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row)
                        },
                      },
                      model: {
                        value: row.isActive,
                        callback: function ($$v) {
                          _vm.$set(row, "isActive", $$v)
                        },
                        expression: "row.isActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Expires At", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.expiresAt
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.formatDate(row.expiresAt))),
                        ])
                      : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                          _vm._v("Never"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Last Used", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.lastUsedAt
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.formatDate(row.lastUsedAt))),
                        ])
                      : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                          _vm._v("Never"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              width: "200",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "info",
                          icon: "el-icon-document",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewLogs(row)
                          },
                        },
                      },
                      [_vm._v(" Logs ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.total > _vm.listQuery.limit
        ? _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              total: _vm.total,
              layout: "total, prev, pager, next",
            },
            on: { "current-change": _vm.handlePageChange },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Create API Key",
            visible: _vm.createDialogVisible,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: {
                model: _vm.createFormData,
                rules: _vm.createRules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "App Name", prop: "appName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., AIM Dashboard" },
                    model: {
                      value: _vm.createFormData.appName,
                      callback: function ($$v) {
                        _vm.$set(_vm.createFormData, "appName", $$v)
                      },
                      expression: "createFormData.appName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Optional description",
                    },
                    model: {
                      value: _vm.createFormData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.createFormData, "description", $$v)
                      },
                      expression: "createFormData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Permissions", prop: "permissions" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.createFormData.permissions,
                        callback: function ($$v) {
                          _vm.$set(_vm.createFormData, "permissions", $$v)
                        },
                        expression: "createFormData.permissions",
                      },
                    },
                    [
                      _c(
                        "el-checkbox",
                        { attrs: { label: "/api/v2/external/aim/**" } },
                        [_vm._v("AIM - All Endpoints")]
                      ),
                      _c(
                        "el-checkbox",
                        { attrs: { label: "/api/v2/external/aim/users" } },
                        [_vm._v("AIM - Users")]
                      ),
                      _c(
                        "el-checkbox",
                        { attrs: { label: "/api/v2/external/aim/stats" } },
                        [_vm._v("AIM - Stats")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#909399",
                        "margin-top": "4px",
                      },
                    },
                    [
                      _vm._v(
                        " Select which endpoints this key can access. Use glob patterns. "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Rate Limit", prop: "rateLimit" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 1, max: 10000, step: 50 },
                    model: {
                      value: _vm.createFormData.rateLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.createFormData, "rateLimit", $$v)
                      },
                      expression: "createFormData.rateLimit",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { "margin-left": "10px", color: "#606266" },
                    },
                    [_vm._v("requests/hour")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Expires At", prop: "expiresAt" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "Leave empty for no expiration",
                    },
                    model: {
                      value: _vm.createFormData.expiresAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.createFormData, "expiresAt", $$v)
                      },
                      expression: "createFormData.expiresAt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.createDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitCreate },
                },
                [_vm._v("Create")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "API Key Created",
            visible: _vm.keyDisplayDialogVisible,
            width: "550px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.keyDisplayDialogVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "16px" },
            attrs: {
              title: "Save this key now! It will not be shown again.",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                background: "#f5f7fa",
                padding: "16px",
                "border-radius": "4px",
                "font-family": "monospace",
                "word-break": "break-all",
              },
            },
            [_vm._v(" " + _vm._s(_vm.createdKeyPlaintext) + " ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "12px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-document-copy" },
                  on: { click: _vm.copyKey },
                },
                [_vm._v(" Copy to Clipboard ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.keyDisplayDialogVisible = false
                    },
                  },
                },
                [_vm._v("I've Saved The Key")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Edit API Key",
            visible: _vm.editDialogVisible,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                model: _vm.editFormData,
                rules: _vm.editRules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "App Name", prop: "appName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editFormData.appName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editFormData, "appName", $$v)
                      },
                      expression: "editFormData.appName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.editFormData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.editFormData, "description", $$v)
                      },
                      expression: "editFormData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Permissions" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.editFormData.permissions,
                        callback: function ($$v) {
                          _vm.$set(_vm.editFormData, "permissions", $$v)
                        },
                        expression: "editFormData.permissions",
                      },
                    },
                    [
                      _c(
                        "el-checkbox",
                        { attrs: { label: "/api/v2/external/aim/**" } },
                        [_vm._v("AIM - All Endpoints")]
                      ),
                      _c(
                        "el-checkbox",
                        { attrs: { label: "/api/v2/external/aim/users" } },
                        [_vm._v("AIM - Users")]
                      ),
                      _c(
                        "el-checkbox",
                        { attrs: { label: "/api/v2/external/aim/stats" } },
                        [_vm._v("AIM - Stats")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Rate Limit" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: { min: 1, max: 10000, step: 50 },
                    model: {
                      value: _vm.editFormData.rateLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.editFormData, "rateLimit", $$v)
                      },
                      expression: "editFormData.rateLimit",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { "margin-left": "10px", color: "#606266" },
                    },
                    [_vm._v("requests/hour")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.editFormData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.editFormData, "isActive", $$v)
                      },
                      expression: "editFormData.isActive",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Expires At" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "Leave empty for no expiration",
                    },
                    model: {
                      value: _vm.editFormData.expiresAt,
                      callback: function ($$v) {
                        _vm.$set(_vm.editFormData, "expiresAt", $$v)
                      },
                      expression: "editFormData.expiresAt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitEdit },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Usage Logs - " + (_vm.logsAppName || ""),
            visible: _vm.logsDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.logsLoading,
                  expression: "logsLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.logsList, border: "", fit: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Endpoint", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.endpoint))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Method", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                row.method === "GET" ? "success" : "primary",
                            },
                          },
                          [_vm._v(_vm._s(row.method))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Status", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                row.statusCode >= 200 && row.statusCode < 300
                                  ? "success"
                                  : row.statusCode >= 400
                                  ? "danger"
                                  : "warning",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.statusCode) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "IP Address", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.ipAddress || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Response (ms)",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          _vm._s(
                            row.responseTimeMs !== null
                              ? row.responseTimeMs
                              : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Time", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.formatDate(row.createdAt)))]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.logsTotal > _vm.logsQuery.limit
            ? _c("el-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  "current-page": _vm.logsQuery.page,
                  "page-size": _vm.logsQuery.limit,
                  total: _vm.logsTotal,
                  layout: "total, prev, pager, next",
                },
                on: { "current-change": _vm.handleLogsPageChange },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }